/**
 * Standortkarte (blocks/location-map): Verhalten auf Touch-Geräten.
 *
 * Maus/Tastatur brauchen kein Script: Der Tooltip erscheint per CSS bei Hover/Fokus,
 * ein Klick auf den Punkt führt zur Niederlassung.
 *
 * Touch (kein Hover): Wie von Karten-Apps gewohnt öffnet der ERSTE Tipp auf einen Punkt
 * nur die Infokarte (.is-open). Zur Niederlassung führt der Link in der Karte oder ein
 * zweiter Tipp auf denselben Punkt. Tipp daneben oder Escape schließt.
 * Ohne JavaScript bleibt der Punkt ein normaler Link.
 */
(function () {
    document.addEventListener("DOMContentLoaded", function () {
        var maps = document.querySelectorAll(".location-map");
        if (!maps.length) return;

        // Eingabeart des letzten Zeigers merken: "click" verrät sie nicht in allen Browsern.
        var lastPointer = "mouse";

        function closeAll(except) {
            document.querySelectorAll(".location-map__spot.is-open").forEach(function (spot) {
                if (spot !== except) spot.classList.remove("is-open");
            });
        }

        maps.forEach(function (map) {
            map.addEventListener(
                "pointerdown",
                function (e) {
                    lastPointer = e.pointerType || "mouse";
                },
                true
            );

            map.addEventListener("click", function (e) {
                var dot = e.target.closest(".location-map__dot");
                if (!dot) return;

                var spot = dot.parentElement;
                var isTouch = lastPointer === "touch" || lastPointer === "pen";

                // Maus/Tastatur oder Karte bereits offen → Link normal folgen.
                if (!isTouch || spot.classList.contains("is-open")) return;

                e.preventDefault();
                closeAll(spot);
                spot.classList.add("is-open");
            });
        });

        // Tastatur-Aktivierung (Enter) löst "click" ohne pointerdown aus → nicht als Touch werten.
        document.addEventListener("keydown", function (e) {
            lastPointer = "keyboard";
            if (e.key === "Escape") closeAll();
        });

        document.addEventListener("click", function (e) {
            if (!e.target.closest(".location-map__spot")) closeAll();
        });
    });
})();
